import { jsx as c, jsxs as a } from "react/jsx-runtime";
import { c as t } from "../../../../clsx-OuTLNxxd.js";
import { useState as f } from "react";
import { CheckboxContained as v } from "./checkboxcontained.js";
const e = {
  "checkbox-contained-group": "_checkbox-contained-group_15j7h_29",
  "checkbox-contained-group-header": "_checkbox-contained-group-header_15j7h_32",
  "checkbox-contained-group-label": "_checkbox-contained-group-label_15j7h_32",
  "checkbox-contained-group-header-error": "_checkbox-contained-group-header-error_15j7h_37",
  "checkbox-contained-group-helper": "_checkbox-contained-group-helper_15j7h_40",
  "checkbox-contained-group-body": "_checkbox-contained-group-body_15j7h_45",
  "checkbox-contained-item": "_checkbox-contained-item_15j7h_51",
  "checkbox-contained-item-by-1": "_checkbox-contained-item-by-1_15j7h_54",
  "checkbox-contained-item-by-2": "_checkbox-contained-item-by-2_15j7h_58",
  "checkbox-contained-item-by-3": "_checkbox-contained-item-by-3_15j7h_68",
  "checkbox-contained-item-by-4": "_checkbox-contained-item-by-4_15j7h_78",
  "checkbox-contained-group-footer": "_checkbox-contained-group-footer_15j7h_88",
  "checkbox-contained-group-footer-error": "_checkbox-contained-group-footer-error_15j7h_93",
  "dialog-overlay-show": "_dialog-overlay-show_15j7h_1",
  "dialog-content-show": "_dialog-content-show_15j7h_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_15j7h_1"
}, $ = ({
  labelContent: h,
  helperContent: d,
  error: n,
  buttonWithDescription: x,
  collapsible: i = !1,
  collapsed: p = !0,
  showMore: k,
  showLess: l,
  showLines: g = 2,
  children: b,
  itemPerLine: _ = 4
}) => {
  const [r, m] = f(p), u = b.length, s = _ * g, j = b.filter((o) => o && o.type === v).filter((o, y) => !i || !r || y < s).map((o) => /* @__PURE__ */ c(
    "div",
    {
      className: t(e["checkbox-contained-item"], e[`checkbox-contained-item-by-${_}`]),
      children: o
    },
    `checkbox-item-${o.props.name}___${o.key || o.props.toString}`
  ));
  return /* @__PURE__ */ a("div", { className: e["checkbox-contained-group"], children: [
    /* @__PURE__ */ a("div", { className: e["checkbox-contained-group-header"], children: [
      h && /* @__PURE__ */ c(
        "div",
        {
          className: t(
            e["checkbox-contained-group-label"],
            n && e["checkbox-contained-group-header-error"]
          ),
          children: h
        }
      ),
      d && /* @__PURE__ */ c("div", { className: e["checkbox-contained-group-helper"], children: d })
    ] }),
    /* @__PURE__ */ c(
      "div",
      {
        className: t(
          e["checkbox-contained-group-body"],
          x && e["checkbox-contained-group-has-description"]
        ),
        children: j
      }
    ),
    (i || n) && /* @__PURE__ */ a("div", { className: t(e["checkbox-contained-group-footer"]), children: [
      /* @__PURE__ */ c("div", { className: e["checkbox-contained-group-footer-error"], children: n && /* @__PURE__ */ c("p", { children: n }) }),
      /* @__PURE__ */ c("div", { children: i && u > s && /* @__PURE__ */ c("button", { type: "button", onClick: () => m(!r), children: r ? k : l }) })
    ] })
  ] });
};
export {
  $ as CheckboxContainedGroup
};
